import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { FormattedMessage, IntlProvider } from 'react-intl';
import messages from '@chama/utils/i18n/messages';
import { Segment } from '@chama/ui-components';
import Spinner from '@chama/ui-components/components/Spinner';
import config from '@app/config';
import { startListeningToDealers } from '@app/actions/dealers';
import PropTypes from 'prop-types';
import { startListeningToFeatures } from '@app/modules/features/redux';
import DebugBar from './DebugBar';
import ToastNotifications from './ToastNotifications';

const mapStateToProps = state => ({
  locale: state.featureToggles.locale,
  firebaseConnected: state.firebase.connected,
  userId: state.auth.chamaID,
  featuresFetched: state.features.featuresFetched,
});

const mapDispatchToProps = {
  startListeningToDealers,
  startListeningToFeatures,
};

class App extends Component {
  componentDidMount() {
    this.props.startListeningToDealers();
  }

  componentDidUpdate() {
    const { featuresFetched, userId } = this.props;
    if (!featuresFetched && userId) {
      this.props.startListeningToFeatures();
    }
  }

  render() {
    const { firebaseConnected, locale, content } = this.props;

    let loading;

    if (!firebaseConnected) {
      loading = (
        <Spinner>
          <FormattedMessage id="loading" />
        </Spinner>
      );
    }

    return (
      <div>
        <IntlProvider locale={locale} key={locale} messages={messages[locale]}>
          <Fragment>
            <ToastNotifications fixed />
            {loading || content}
          </Fragment>
        </IntlProvider>
        <DebugBar />
        <Segment apiKey={config.segment.apiKey} />
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(App);

App.propTypes = {
  locale: PropTypes.string.isRequired,
  content: PropTypes.object.isRequired,
  firebaseConnected: PropTypes.bool.isRequired,
  startListeningToDealers: PropTypes.func.isRequired,
  startListeningToFeatures: PropTypes.func.isRequired,
  userId: PropTypes.string,
  featuresFetched: PropTypes.bool.isRequired,
};
App.defaultProps = {
  userId: null,
};



// WEBPACK FOOTER //
// ./src/containers/App.jsx